import React from "react";
import { useTranslation } from "react-i18next";
import { ContextHelp } from "../../ui";

/**
 * ConversationFilters component for filtering and searching conversations
 * @param {Object} props - Component props
 * @param {string} props.statusFilter - Currently active status filter
 * @param {Function} props.onStatusFilterChange - Callback when status filter changes
 * @param {string} props.statusReasonFilter - Currently active status reason filter
 * @param {Function} props.onStatusReasonFilterChange - Callback when status reason filter changes
 */
const ConversationFilters = ({
  statusFilter,
  onStatusFilterChange,
  statusReasonFilter,
  onStatusReasonFilterChange,
}) => {
  const { t } = useTranslation("conversations");

  const statusOptions = [
    { value: "all", label: t("filters.status.all") },
    { value: "active", label: t("filters.status.active") },
    { value: "closed", label: t("filters.status.closed") },
    { value: "writing", label: t("filters.status.writing") },
  ];

  const statusReasonOptions = [
    { value: "all", label: t("filters.reason.all") },
    { value: "completed", label: t("filters.reason.completed") },
    { value: "abandoned", label: t("filters.reason.abandoned") },
    { value: "failed", label: t("filters.reason.failed") },
  ];

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:flex-wrap">
      {/* Status Filter */}
      <div className="min-w-0 flex-1 sm:min-w-48">
        <div className="flex items-center gap-2">
          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            aria-label={t("help.filters.status.ariaLabel")}
            className="custom-select border-border bg-background text-foreground focus:ring-ring block min-h-11 min-w-0 flex-1 rounded-md border px-3 py-2 text-sm focus:ring-2 focus:outline-none"
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ContextHelp
            className="h-3.5 w-3.5"
            ariaLabel={t("help.filters.status.ariaLabel")}
            whatIs={t("help.filters.status.whatIs")}
          />
        </div>
      </div>

      {/* Status Reason Filter */}
      <div className="min-w-0 flex-1 sm:min-w-48">
        <div className="flex items-center gap-2">
          <select
            value={statusReasonFilter}
            onChange={(e) => onStatusReasonFilterChange(e.target.value)}
            aria-label={t("help.filters.reason.ariaLabel")}
            className="custom-select border-border bg-background text-foreground focus:ring-ring block min-h-11 min-w-0 flex-1 rounded-md border px-3 py-2 text-sm focus:ring-2 focus:outline-none"
          >
            {statusReasonOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ContextHelp
            className="h-3.5 w-3.5"
            ariaLabel={t("help.filters.reason.ariaLabel")}
            whatIs={t("help.filters.reason.whatIs")}
          />
        </div>
      </div>
    </div>
  );
};

export default ConversationFilters;
